import {getStorage, getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import { firebase } from "../../../services/firebase";
import { toast } from "react-toastify";


export const fileUpload = async (file, userData, setUserData, setIsImageUploaded, setIsImageUploading, setProgress) => {
  const firebaseStorage = getStorage(firebase);
  try {
    setIsImageUploading(true);
    const storageRef = ref(firebaseStorage, `images/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
      },
      (error) => {
        console.error("File upload error:", error);
        toast.error("Failed to upload file! Please try again.");
        setIsImageUploading(false);
        throw error;
      },
      async () => {
        try {
          const downloadURL = await getDownloadURL(storageRef);
          console.log(downloadURL);
          setUserData({ ...userData, photo_url: downloadURL });
          setIsImageUploaded(true);
          setIsImageUploading(false);
          toast.success("File uploaded successfully!");
        } catch (error) {
          console.error("Error getting download URL:", error);
          toast.error("Failed to get download URL! Please try again.");
        }
      }
    );
    await uploadTask;
  } catch (error) {
    console.error("File upload error:", error);
    toast.error("Failed to upload file! Please try again.");
    setIsImageUploading(false);
    throw error;
  }
};